
import { View } from 'backbone';
import Template from 'behaviors/properties/main/close.ejs';
import widgetUtil     from 'util/WidgetUtil.js';
//=====================================================================
//
// An instance of this view represents a close.
//
// Casey Justus, May 6, 2016 
//
//=====================================================================

class MainCloseView extends View {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=radio]'      : 'updateAttributes'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
        this.render();
    }


    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.model.set('widgetText', widgetUtil.getWidgetText(this.model));
        $("input:radio[value='"+this.model.get('closeOption')+"']").attr('checked', true);

        this.delegateEvents();
        return this;
    }

}

export default MainCloseView;
